import React from 'react'
import { Body } from './text'

const Loading: React.FunctionComponent = () => <Body>Loading...</Body>

export default Loading
